export const getColumnDataState = (dataLength?: number) => {
    if (dataLength === undefined) {
        return 'Načítám...'
    }

    if (dataLength === 0) {
        return 'Žádné objednávky'
    }
}
